import { ResolveFn } from '@angular/router';
import { DestroyRef, inject } from '@angular/core';
import { PoService } from '../../services/po/po.service';
import { POBankDetails, PODetailsResponse } from '../../models/po';
import { forkJoin } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonService } from '../../services/common/common.service';

interface PoAllDetails {
  details: PODetailsResponse;
  bankDetails: POBankDetails;
}

export const poDetailsResolver: ResolveFn<
  Pick<PoAllDetails, 'details'> | PoAllDetails
> = (route, state) => {
  const poService = inject(PoService);
  const commonService = inject(CommonService);
  const destroyRef = inject(DestroyRef);

  const poId = route.params['id'];
  if (state.url.includes('buyer')) {
    return forkJoin({
      bankDetails: commonService.getContractorBankDetails(),
      details: poService.getBuyerPoDetails(poId),
    }).pipe(takeUntilDestroyed(destroyRef));
  } else {
    return forkJoin({
      details: poService.getSupplierPoDetails(poId),
    }).pipe(takeUntilDestroyed(destroyRef));
  }
};
